// extracted by mini-css-extract-plugin
export default {"description":"style_description__09hWt","fade-in":"style_fade-in__T7S5G","top":"style_top__280Wj","image":"style_image__muz5y"};